import React, { useState, useCallback, useEffect } from 'react';
import { useBoolean } from '@sravni/react-utils';
import { OutOfPageTypes, BannerFromIframeToBannerType } from '../../types/index.js';
import { FullScreenWrapper } from '../components/FullScreenWrapper/index.js';
import { MobileBottomWrapper } from '../components/MobileBottomWrapper/index.js';

const outOfPageWrappersMap = {
    [OutOfPageTypes.MOBILE_BOTTOM]: MobileBottomWrapper,
    [OutOfPageTypes.FULLSCREEN]: FullScreenWrapper,
};
const useOutOfPageBanner = (isOutOfPage, className) => {
    const [isBannerShown, setBannerShown] = useBoolean(false);
    const [bannerInfo, setBannerInfo] = useState(null);
    const [bannerType, setBannerType] = useState();
    const messageListener = useCallback(({ data: dataFromMessage }) => {
        if (!dataFromMessage || isBannerShown) {
            return;
        }
        let data = null;
        try {
            data = typeof dataFromMessage === 'string' ? JSON.parse(dataFromMessage) : dataFromMessage;
        }
        catch (_) {
            data = dataFromMessage;
        }
        if (Object.keys(BannerFromIframeToBannerType).includes(data.type)) {
            // @ts-expect-error
            setBannerType(BannerFromIframeToBannerType[data.type]);
            setBannerInfo(data.branding);
        }
    }, [isBannerShown]);
    useEffect(() => {
        if (!isOutOfPage)
            return;
        window.addEventListener('message', messageListener);
        return () => {
            window.removeEventListener('message', messageListener);
        };
    }, [isOutOfPage, messageListener]);
    if (!bannerInfo)
        return null;
    const WrapperByType = bannerType ? outOfPageWrappersMap[bannerType] : null;
    if (!WrapperByType)
        return null;
    return React.createElement(WrapperByType, { bannerInfo: bannerInfo, setBannerShown: setBannerShown.on, className: className });
};

export { useOutOfPageBanner };
//# sourceMappingURL=outOfPage.js.map
